import { useState, useRef, useEffect } from 'react'
import { useMutation } from 'components/graphql'

const useMultiEdit = ({ sectionData }) => {
	const { multiEditMutation: mutation, link: subsection } = sectionData
	const [isActive, setIsActive] = useState(false)
	const [recordIds, setRecordIds] = useState([])
	const [multiEdit] = useMutation(mutation)
	const baseRecordId = useRef()

	useEffect(() => {
		setIsActive(false)
		setRecordIds([])
	}, [subsection])

	const handleMultiEdit = ({ fields }) => {
		return multiEdit({
			variables: {
				idArr: recordIds,
				fields
			}
		})
	}

	const handleSetIsActive = (isActiveVal, id) => {
		if(isActiveVal) {
			baseRecordId.current = id
			handleSelectRecord(id)
		} else {
			setRecordIds([])
		}
		setIsActive(isActiveVal)
	}

	const handleSelectRecord = id => {
		const isSelected = isRecordSelected(id)
		if(id === baseRecordId.current && isSelected) {
			return
		}
		setRecordIds(idArr => isSelected ?
			idArr.filter(recordId => recordId !== id) :
			[id, ...idArr]
		)
	}

	const isRecordSelected = id => recordIds.indexOf(id) !== -1


	return {
		isActive,
		setIsActive: handleSetIsActive,
		recordIds,
		setRecordIds,
		handleMultiEdit,
		handleSelectRecord,
		isRecordSelected
	}
}

export default useMultiEdit
